// 足球
// 状态码 |    描述
// | ------ | ------------------------------------------------------------------------------
// | 0      | 比赛异常，说明：暂未判断具体原因的异常比赛，可能但不限于：腰斩、取消等等，建议隐藏处理
// | 1      | 未开赛
// | 2      | 上半场
// | 3      | 中场
// | 4      | 下半场
// | 5      | 加时赛
// | 6      | 加时赛(弃用)
// | 7      | 点球决战
// | 8      | 完场
// | 9      | 推迟
// | 10     | 中断
// | 11     | 腰斩
// | 12     | 取消
// | 13     | 待定

// 篮球
// 状态码 | 描述
// | ------ | ------------------------------------------------------------------------------
// | 0 | 比赛异常，说明：暂未判断具体原因的异常比赛，可能但不限于：腰斩、取消等等，建议隐藏处理
// | 1 | 未开赛
// | 2 | 第一节
// | 3 | 第一节完
// | 4 | 第二节
// | 5 | 第二节完
// | 6 | 第三节
// | 7 | 第三节完
// | 8 | 第四节
// | 9 | 加时
// | 10 | 完场
// | 11 | 中断
// | 12 | 取消
// | 13 | 延期
// | 14 | 腰斩
// | 15 | 待定

import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, ButtonBase, Avatar } from '@material-ui/core';
import DateUtils from '../../../control/dateutils'
import Match from '../../../model/Match';
import AppData from '../../../model/AppData';
import Live from '../../../model/Live';

const ICON = require("../../../images/icons/faxian_icon.png");
const ICON_HOT = require("../../../images/icons/remen.png");
const ICON_SC = require("../../../images/icons/shoucan.png");
const ICON_SCT = require("../../../images/icons/shoucan2.png");
const PLAYICON = require("../../../images/icons/living.gif");

const ICON_SOURCE = require("../../../images/icons/ic_nami_soruce.png");

class MatchItem extends React.Component {

    constructor(props) {
        super(props);
    }

    _onClicAnchor = (e, data) => {
        e.stopPropagation();
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.type_id ? data.type_id : 0;
        let match_id = data.id ? data.id : 0;
        this.props.history.push({ pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data });
    }

    showPlay = (data) => {
        if (!data.nami) {
            return false;
        }
        if (data.nami.length == 0) {
            return false;
        }
        let liveSource = '';
        data.nami.forEach(element => {
            if (element.live_url.length > 0) {
                liveSource = element.live_url;
            }
        });
        return liveSource.length > 0;
    }

    render() {
        const { classes, data, line } = this.props;
        let match = new Match(data);
        let status = match.getStatus();
        let timer = DateUtils.dateFormatHM(data.match_time);
        let vs = match.getVs();
        let star = AppData.isStarMatch(match.type_id, match.id);
        // if (match.host.length > 0) {
        //     console.log('=================>', data);
        // }

        let showPlay = this.showPlay(match);
        return (
            <ButtonBase onClick={(e) => this._onClicAnchor(e, data)} >
                <Grid container justify='space-between' alignItems='center' direction='column' style={{ width: '100vw' }} >
                    <Grid container alignItems='center' justify='space-between' direction='row' style={{ flex: 1, marginTop: 16 }}>
                        <Grid container alignItems='center' direction='row' style={{ maxWidth: '40vw' }} >
                            <Typography style={{ fontSize: 10, color: '#FF0000', marginLeft: 8 }}>{data.short_name_zh}</Typography>
                            <Typography style={{ fontSize: 10, color: '#878787', marginLeft: 16 }}>{timer}</Typography>
                        </Grid>
                        <Typography style={{ fontSize: 10, color: '#878787', marginRight: 8 }}>{status}</Typography>
                        {/* <Grid container alignItems='center' direction='row' justify='flex-end' style={{ maxWidth: '40vw' }}> */}
                        {/* <img src={ICON} style={{ width: 14, height: 14, marginRight: 4, marginLeft: 8 }}></img>
                        <img src={ICON} style={{ width: 14, height: 14, marginRight: 8, marginLeft: 4 }}></img> */}
                        {/* </Grid> */}
                    </Grid>
                    <Grid container alignItems='center' justify='space-between' direction='row'>
                        {
                            data.is_hot == 1 && <img src={ICON_HOT} style={{ width: 28.5, height: 14, marginLeft: 8, marginTop: 8 }}></img>
                        }
                    </Grid>
                    <Grid container spacing={0} alignItems='center' justify='center' direction='row' style={{ marginTop: 16, marginBottom: 16 }}>
                        <img src={star ? ICON_SCT : ICON_SC} style={{ width: 12, height: 12, position: 'absolute', left: 16 }}></img>
                        <Grid container alignItems='center' justify='flex-end' direction='row' style={{ width: '40vw' }}>
                            <Typography noWrap={true} style={{ fontSize: 14, color: '#0D0D0D', marginRight: 8, maxWidth: 80 }}>{data.home_name}</Typography>
                            <img src={data.home_log} style={{ width: 24, height: 24, marginRight: 8 }}></img>
                        </Grid>
                        <Typography style={{ marginLeft: 8, marginRight: 8, fontSize: 13, color: '#0D0D0D' }}>{vs}</Typography>
                        <Grid container alignItems='center' justify='flex-start' direction='row' style={{ width: '40vw' }}>
                            <img src={data.away_log} style={{ width: 24, height: 24, marginLeft: 8 }}></img>
                            <Typography noWrap={true} style={{ fontSize: 14, color: '#0D0D0D', marginLeft: 8, maxWidth: 80 }}>{data.away_name}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container alignItems='center' justify='center' direction='row'>
                        {
                            (match.host && match.host.length > 0 || match.nami && match.nami.length > 0) && <Grid container alignItems='center' justify='center' direction='row'>
                                {
                                    match.host && match.host.map((item, i) => (
                                        <Grid key={i} container alignItems='center' direction='column' onClick={(e) => this._onClicAnchor(e, item)} style={{ marginBottom: 8, maxWidth: 80 }} >
                                            <Avatar src={item.portrait} style={{ width: 32, height: 32, marginLeft: 4, marginRight: 4, }}></Avatar>
                                            <Grid className={classes.playIcon}>
                                                {
                                                    item.live_status == Live.STATUS_LIVE && <img src={PLAYICON} style={{ width: 10, height: 10 }}></img>
                                                }
                                            </Grid>
                                            <Typography noWrap={true} style={{ fontSize: 11, color: '#0D0D0D', maxWidth: 80, marginTop: 4 }}>{item.nickName}</Typography>
                                        </Grid>
                                    ))
                                }
                                {
                                    showPlay && <Grid container alignItems='center' justify='center' direction='column' style={{ marginBottom: 8, maxWidth: 80 }}>
                                        <img src={ICON_SOURCE} style={{ width: 32, height: 32 }}></img>
                                        <Typography noWrap={true} style={{ fontSize: 11, color: '#0D0D0D', marginTop: 8 }}>视频源</Typography>
                                    </Grid>
                                }
                            </Grid>
                        }
                        {
                            (!match.host || match.host.length == 0) && <Typography style={{ fontSize: 10, color: '#878787', marginLeft: 8, marginBottom: 16 }}>{match.getScoreVs()}</Typography>
                        }
                    </Grid>
                    {
                        line && <Grid style={{ width: '100%', height: 5, backgroundColor: '#F6F6F6' }}></Grid>
                    }
                </Grid>
            </ButtonBase>

        );
    }

}

export default withRouter(withStyles((theme) => ({
    playIcon: {
        width: 10,
        height: 10,
        margin: theme.spacing(-0.5, 0, 0, 0),
        zIndex: 1000,
    },
}))(MatchItem));